import React, { useState, useEffect } from "react";
import "./NavBar.css";
import { NavLink } from "react-router-dom";
import { MenuItems } from "../../assets/utils/MenuItems";
import ChauwkEntpPortalLogo from "../../assets/images/logo-chauwk-entpportal.png";

const NavBar = () => {
  const [clicked, setClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 850);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const redirectToEnterprisePortal = () => {
    // Fire Facebook Pixel Event
    if (window.fbq) {
      window.fbq('trackCustom', 'TryForFreeClick');
    }
    
    // Fire Google Analytics Event
    if (window.gtag) {
      window.gtag('event', 'click_try_for_free', {
        'event_category': 'Button',
        'event_label': 'Try For Free Nav Button'
      });
    }

    window.location.href = "https://www.enterprise.chauwk.com/register";
  };


  const handleClick = () => {
    setClicked(!clicked);
  };

  const handleMenuItemClick = () => {
    setClicked(false);
  };

  return (
    <nav className="nav">
      <div className="logo">
        <img src={ChauwkEntpPortalLogo} alt="Chauwk" />
      </div>

      {/* Beautiful Hamburger Menu Icon */}
      <div className="menu-icons" onClick={handleClick}>
        <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
      </div>

      {/* Beautiful Mobile Menu */}
      <ul className={clicked ? "nav-menu active" : "nav-menu"}>
        {MenuItems.map((item, index) => (
          <li key={index}>
            <NavLink
              to={item.url}
              className={({ isActive }) =>
                `${item.cName} ${isActive ? "active" : ""}`
              }
              onClick={handleMenuItemClick}
            >
              {item.title}
            </NavLink>
          </li>
        ))}

        {/* Beautiful Try for Free Button */}
        <li>
          <div className="Mission-heading">
            <button
              className="btn gradient"
              onClick={() => {
                redirectToEnterprisePortal();
                handleMenuItemClick();
              }}
            >
              Try for Free
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default NavBar;
